<template>
  <div class="tab1">
    <div class="box1">
      <div class="title">
        <div class="icon">
          <span class="before"></span>
          <span class="after"></span>
        </div>
        <div>ESG七大主题课程</div>
      </div>
      <div class="desc">
        2020年12月，中央经济工作会议明确提出碳减排“30·60”目标，碳达峰、碳中和成为促进我国经济社会绿色转型、实现绿色发展的重要抓手。在我国“十四五”经济发展转型期，绿色发展作为经济发展的新动力，将推动经济实现可持续、高质量发展。我国越来越多企业关注绿色金融、碳中和及ESG方面的议题，为满足市场对绿色金融、碳中和、ESG方面的专业人才需求，中经社联合中央财经大学绿色金融国际研究院、北京绿色金融与可持续发展研究院等机构的绿色金融、ESG和碳中和专家，开展绿色金融相关内容的培训服务。
      </div>
      <div class="img1-1"></div>
    </div>
    <div class="title">
      <div class="icon">
        <span class="before"></span>
        <span class="after"></span>
      </div>
      <div>ESG培训课程</div>
    </div>
    <div class="itemContainer">
      <div class="img1-2"></div>
      <div class="itemRight">
        <div class="itemTopTitle">中国绿色金融发展</div>
        <div class="itemDesc">本课程围绕可持续发展重要议题，从宏观视角以金融的绿色化转型、绿色金融支持我国“双碳”实现展开，明确资本经济体系可持续发展的重要性，并以政策和市场端发展、地方绿色金融实验区实践展现我国绿色金融发展成果和未来机遇。</div>
        <div class="itemBottomBox">
          <div class="itemIcon"></div>
          <div class="itemTitle">课程安排：</div>
            <div class="itemBottomDesc">可持续发展与绿色金融、我国绿色金融发展现状（政策&市场）、地方绿色金融改革创新试验区的发展、“双碳”目标下绿色金融新机遇</div>
        </div>
      </div>
    </div>
    <div class="itemContainer">
      <div class="img1-3"></div>
      <div class="itemRight">
        <div class="itemTopTitle">企业ESG披露与风险管理</div>
        <div class="itemDesc">本课程将进一步聚焦国内外时下逐步主流化发展的ESG，从内涵与可持续发展核心议题展开，剖析时下ESG信息披露的政策要求，明确企业执行ESG信息披露的重要性及框架，并以正负面案例为参考，提出现阶段相关信息披露面临的困境与挑战。</div>
        <div class="itemBottomBox">
          <div class="itemIcon"></div>
          <div class="itemTitle">课程安排：</div>
          <div class="itemBottomDesc">ESG的起源与发展、国内外ESG信息披露发展、企业ESG信息披露的重要性、ESG助力企业风险管理、
企业 ESG信息披露框架、ESG信息披露实践与案例分析、ESG信息披露发展的机遇与挑战
</div>
        </div>
      </div>
    </div>
    <div class="itemContainer">
      <div class="img1-4"></div>
      <div class="itemRight">
        <div class="itemTopTitle">碳中和</div>
        <div class="itemDesc">要实现碳达峰、碳中和发展目标，关键在于以高碳排放强度为典型特色的棕色资产有序的绿色转型。</div>
        <div class="itemBottomBox">
          <div class="itemIcon"></div>
          <div class="itemTitle">课程安排：</div>
          <div class="itemBottomDesc">应对气候变化背景、应对气候变化的政策框架、碳中和实现路径、绿色金融支持碳中和目标实现
企业 ESG 信息披露框架、ESG 信息披露实践与案例分析(正面&负面)、ESG 信息披露发展的机遇与挑战、
“碳中和”目标下的产业机遇和挑战、“双碳”目标下，企业发展新战略
</div>
        </div>
      </div>
    </div>
    <div class="itemContainer">
      <div class="img1-5"></div>
      <div class="itemRight">
        <div class="itemTopTitle">环境权益市场</div>
        <div class="itemDesc">环境权益交易在国外已有先例，用于减少能源消耗。中国是能耗大国，节能减排是贯彻绿色发展理念，经济发展新常态下的必然途径。目前，中国仍处于环境权益市场的起步阶段，就各类环境权益的定价、交易、配额等制度还处于初步阶段，未来随着市场进一步发展，将对企业的生产和经营模式产生变革性影响。</div>
        <div class="itemBottomBox">
          <div class="itemIcon"></div>
          <div class="itemTitle">课程安排：</div>
          <div class="itemBottomDesc">环境权益概念、环境权益交易制度、环境权益市场进展

</div>
        </div>
      </div>
    </div> 
    <div class="itemContainer">
      <div class="img1-6"></div>
      <div class="itemRight">
        <div class="itemTopTitle">ESG基础知识课程</div>
        <div class="itemDesc">环境、社会和公司治理是三个基于价值的评估因素，即业务和投资活动对环境的影响、对社会的影响，以及公司治理是否完善等。本课程将对国际通用ESG标准、不同国家地区的ESG信息披露相关标准以及部分NGO组织的ESG相关标准进行解读，帮助了解ESG信息披露的规范性；并对我国ESG相关政策体系进行梳理并深入解读，以更好了解我国顶层设计的发展趋势。</div>
        <div class="itemBottomBox">
          <div class="itemIcon"></div>
          <div class="itemTitle">课程安排：</div>
          <div class="itemBottomDesc">ESG的起源与发展、国际ESG信息披露标准介绍、我国ESG相关政策发展解读

</div>
        </div>
      </div>
    </div> 
    <div class="itemContainer">
      <div class="img1-7"></div>
      <div class="itemRight">
        <div class="itemTopTitle">全球ESG投资发展与趋势</div>
        <div class="itemDesc">本课程从投资者视角展开，从新冠疫情对金融投资市场的冲击伊始，到ESG投资以稳健的投资绩效异军突起进而演化为现今的主流化发展态势。还将进一步分析主流金融机构采取的投资策略，结合实例分析展望ESG投资未来的发展机遇与挑战。</div>
        <div class="itemBottomBox">
          <div class="itemIcon"></div>
          <div class="itemTitle">课程安排：</div>
          <div class="itemBottomDesc">新冠疫情对投资市场的影响、ESG国内外投资发展现状、国内外ESG指标体系、ESG主流投资策略、
疫情期间ESG投资策略分析、企业ESG案例分析、ESG投资棉铃的机遇与挑战

</div>
        </div>
      </div>
    </div>               
                
  </div>
</template>
<script>
//import { mapActions } from "vuex";
//import List from "./components/List";
export default {
  data() {
    return {
      
      //activeName: "0",
    };
  },
  components: {
   /*  List, */
  },
  computed: {

  },//
  mounted() {
    /* this.getLeftMenuList().then((data) => {
      this.leftMenus = data;
    }); */
  },
  methods: {
    /* ...mapActions("dynamicInfo/index", {
      getTabMenuList: "GET_TAB_MENU_LIST",
    }), */
    /* leftSelect(index) {
      let currentMenu = this.leftMenus[index];
      this.classifyCode = currentMenu.code;
    }, */
/*     handleClick(tab, event) {
        console.log(tab, event);
        let code=tab.name;
        console.log(tab.name)
          this.getInfoList(code).then((data)=>{
          console.log(data)
          this.infoList=data.data
        })
        
        
      }  */   
  },
};
</script>
<style lang="scss" scoped>
.Black{
  .tab1{
    .img1-1{
        
        background: url('../../../assets/black_theme/esg-college-tab3-1.png') no-repeat;
        background-position: center;
        background-size: cover;
        
      }
      .itemContainer{
        .itemRight{
          border: 1px solid #223750;
          background-color: #011A36;
          .itemBottomBox{
            .itemIcon{

            }
          }
        }
      }
      
  }
}
    .tab1{
      width: 100%;
      //height: 438px;
      margin: 0 auto;
      .title{
        width: 1100px;
        margin: 0 auto;
        display: flex;
        margin-top: 10px;
        margin-bottom: 20px;
        padding-left: 2px;
        font-weight: bold;
        font-size: 16px;
        color: var(--font_01);
        .icon{
          position: relative;
          margin-right: 10px;
          margin-top: 4px;
          .before{
            position: absolute;
            top: 2px;
            left: -2px;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
          }
          .after{
            display: block;
            width: 10px;
            height: 10px;
            background-color: #008BCE;
            opacity: 0.19;
          }

        }
      }
      .desc{
        line-height: 22px;
        margin-bottom: 20px;
        color: var(--font_01);
        
      }
      .box1{
        width: 1100px;
        margin: 0 auto;
      }
      .img1-1{
        width: 734px;
        height: 186px;
        margin: 0 auto;
        background: url('../../../assets/black_theme/esg-college-tab3-1.png') no-repeat;
        background-position: center;
        background-size: cover;
        margin-bottom: 80px;
      }
      .itemContainer{
        display: flex;
        justify-content: space-between;
        width: 1020px;
        height: 177px;
        margin: 30px auto;
        .img1-2{
          width: 300px;
          height: 177px;
          background: url('../../../assets/white_theme/esg-college-tab3-2.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .img1-3{
          width: 300px;
          height: 177px;
          background: url('../../../assets/white_theme/esg-college-tab3-3.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .img1-4{
          width: 300px;
          height: 177px;
          background: url('../../../assets/white_theme/esg-college-tab3-4.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .img1-5{
          width: 300px;
          height: 177px;
          background: url('../../../assets/white_theme/esg-college-tab3-5.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .img1-6{
          width: 300px;
          height: 177px;
          background: url('../../../assets/white_theme/esg-college-tab3-6.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .img1-7{
          width: 300px;
          height: 177px;
          background: url('../../../assets/white_theme/esg-college-tab3-7.png') no-repeat;
          background-position: center;
          background-size: cover;
        }
        .itemRight{
          width: 720px;
          padding: 36px;
          background-color: #fff;
          .itemTopTitle{
            font-weight: 600;
            color: var(--font_01);
            line-height: 27px;
          }
          .itemDesc{
            font-size: 12px;
            line-height: 17px;
            margin-bottom: 14px;
            color: var(--font_01);
          }
          .itemBottomBox{
            display: flex;
            align-items: baseline;
            .itemIcon{
              width: 10px;
              height: 10px;
              background-color: #0064FB;
              border-radius: 50%;
              margin-right: 8px;
            }
            .itemTitle{
              font-size: 12px;
              font-weight: 600;
              color: var(--font_01);
              margin-right: 8px;
              //line-height: 27px;
            }
            .itemBottomDesc{
              font-size: 12px;
              width: 552px;
              height: 63px;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 3;
              color: #0064FB;
            }
          }
        }
      }

      
    }
  
    

</style>
